
const url = require('url');

const _ = require('lodash');

import ko from 'rgs-knockout';

const { momentReprExtend } = require('ko-extender-repr-moment-from-iso');

const moment = require('moment');

const { JSable } = require('jsable');

const DATE_FORMAT = 'DD.MM.YYYY';

const readableProductNames = {
	Travel3: 'страхования выезжающих за рубеж',
	Flat: 'страхования квартиры',
	Mite: 'страхования от укусов клещей',
	Osago: 'ОСАГО',
};

module.exports = class PolicyForProlongation extends JSable {
	constructor (options) {
		super();

		this.QuotationCaseID = ko.observable()
			.extend({ toFromJS: true });

		this.OrderID = ko.observable()
			.extend({ toFromJS: true });

		this.InsurancePeriodEnd = ko.observable()
			.extend(momentReprExtend)
			.extend({ toFromJS: true });

		this.InsuranceProductType = ko.observable()
			.extend({ toFromJS: true });

		this.InsuranceProductTypeName = ko.observable()
			.extend({ toFromJS: true });

		this.PolicySeries = ko.observable()
			.extend({ toFromJS: true });

		this.PolicyNumber = ko.observable()
			.extend({ toFromJS: true });

		this.CalcBaseUrl = ko.pureComputed(() => {
			const productType = this.InsuranceProductType();
			return _.get(options.config.cms.pageUrls, [
				'currentSite',
				'productTypes',
				productType,
				'calc',
			], '');
		});

		this.ReadableProductName = ko.pureComputed(
			() => readableProductNames[this.InsuranceProductType()] || ''
		);

		this.IsExpired = ko.pureComputed(() => {
			const now = moment();
			const endPeriod = moment(this.InsurancePeriodEnd(), DATE_FORMAT);

			return now.isAfter(endPeriod);
		});

		this.AutomaticProlongationPolicyUrl = ko.pureComputed(() => {
			const caseID = this.QuotationCaseID();
			const calcBaseUrl = this.CalcBaseUrl();

			if (this.InsuranceProductType() === 'Osago') {
				return caseID && calcBaseUrl && url.format(_.extend(url.parse(calcBaseUrl), {
					search: undefined,
					query: { orderID: this.OrderID() },
				}));
			}

			return caseID && calcBaseUrl && url.format(_.extend(url.parse(calcBaseUrl), {
				search: undefined,
				query: {
					mode: 'prolong',
					caseID,
				},
			}));
		});
	}
};
